import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import fp from 'lodash/fp';
import { withClient } from '@deerplusofficial/pos-hoc';
import { createCancelToken, mapState } from '@deerplusofficial/pos-helper';
import withCartProps, { getItemDiscount } from '../../assist/withCartProps';

const getSpecsString = fp.compose(
  fp.join('-'),
  fp.flatten,
  fp.toPairs
);

export default config => Component =>
  fp.compose(
    withClient(),
    withCartProps(),
    connect(mapState(['preOrder', 'cart', 'order']))
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithPrintPreOrder');

      state = {
        isPreOrderPrinting: false,
      };

      componentWillUnmount() {
        !_.isUndefined(this.cancelPrintPreOrder) && this.cancelPrintPreOrder();
      }

      onPreOrderPrint = async () => {
        const {
          totalDiscount,
          totalPrice: total,
          tax: { value: tax },
          cart: { items },
          preOrder: { id, name },
          client: { POSApi, onError },
        } = this.props;

        this.setState({ isPreOrderPrinting: true });

        try {
          const details = _.size(items)
            ? _.map(items, (item, itemId) => {
                const {
                  name,
                  quantity,
                  unit_price,
                  retail_price,
                  discount,
                  specs,
                } = item;
                const price = unit_price || retail_price;
                const subtotal = price * quantity;

                let description;
                if (_.size(specs)) description = getSpecsString(specs);

                let discountValue;
                if (_.size(discount))
                  discountValue = getItemDiscount(item, itemId);

                return {
                  name,
                  quantity,
                  subtotal,
                  description,
                  unit_price: price,
                  discount: discountValue,
                };
              })
            : [
                {
                  name: '自訂商品',
                  quantity: 1,
                  unit_price: total,
                  subtotal: total,
                  discount: totalDiscount,
                },
              ];

          await POSApi.post(
            `/print/pre_order`,
            { id, name, total, tax, details, discount_amount: totalDiscount },
            { cancelToken: createCancelToken(this.cancelPrintPreOrder) }
          );
        } catch (error) {
          onError(error);
        } finally {
          this.setState({ isPreOrderPrinting: false });
        }
      };

      render() {
        return (
          <Component
            {...this.state}
            {...this.props}
            onPreOrderPrint={this.onPreOrderPrint}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withPrintPreOrder.js